class AuthService {
  login(accessToken, refreshToken, isSuperAdmin, userAssignments, InstituteEmailID) {
    localStorage.setItem('accessToken', accessToken);
    localStorage.setItem('refreshToken', refreshToken);
    localStorage.setItem('isSuperAdmin', isSuperAdmin);
    localStorage.setItem('userAssignments', JSON.stringify(userAssignments));
    localStorage.setItem('InstituteEmailID', InstituteEmailID);
  }

  logout(navigate) {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('isSuperAdmin');
    localStorage.removeItem('userAssignments');
    localStorage.removeItem('InstituteEmailID');
    localStorage.removeItem('activeRole');
    navigate('/login');
  }

  isAuthenticated() {
    return !!localStorage.getItem('accessToken');
  }

  isSuperAdmin() {
    return localStorage.getItem('isSuperAdmin') === 'true';
  }

  getUserAssignments() {
    const assignments = localStorage.getItem('userAssignments');
    return assignments ? JSON.parse(assignments) : [];
  }

  hasAnyRole(requiredRoles) {
    if (this.isSuperAdmin()) return true;

    const assignments = this.getUserAssignments();
    const userRoles = assignments.map(a => a.role);

    if (Array.isArray(requiredRoles)) {
      return requiredRoles.some(role => userRoles.includes(role));
    } else {
      return userRoles.includes(requiredRoles);
    }
  }

  getRefreshToken() {
    return localStorage.getItem('refreshToken');
  }

  getInstituteEmailID() {
    return localStorage.getItem('InstituteEmailID');
  }

  // NEW: Active Role Management
  setActiveRole(roleObject) {
    localStorage.setItem('activeRole', JSON.stringify(roleObject));
  }

  getActiveRole() {
    const role = localStorage.getItem('activeRole');
    return role ? JSON.parse(role) : null;
  }
}

export default new AuthService();
